import React from 'react'

interface DividerProps extends React.HTMLAttributes<HTMLHRElement> {
  margin?: string
}

const Divider: React.FC<DividerProps> = ({
  margin = '1.5rem 0 0.5rem 0',
  ...props
}) => {
  return (
    <hr
      style={{
        margin: margin,
      }}
      className="flex-grow-0 flex-shrink-0 basis-0 flex w-full border-t-body/80 border-t"
      {...props}
    />
  )
}

export default Divider
